import React, { Component } from "react";
import CssClasses from "./Dashboard.css";
import { AreaChart, Area, XAxis, YAxis, Tooltip } from "recharts";

import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";
import * as AdminScreens from "../../../HOCs/Constants/AdminScreenIDs";

import { GetDashboardStats } from "../../../Communication/AdminServicesHandler";

import SiteIcons from "../../../assets/fonts/site_icons/style.css";

let moment = require("moment");

class Dashboard extends Component {
  state = {
    totalTickets: 0,
    totalPayIn: 0,
    totalPayOut: 0,
    remainingPaperMM: 0,
    dataBetCount: [
      { name: "-", Broj: 0 },
      { name: "-", Broj: 0 },
      { name: "-", Broj: 0 },
      { name: "-", Broj: 0 },
      { name: "-", Broj: 0 },
      { name: "-", Broj: 0 },
      { name: "-", Broj: 0 },
      { name: "-", Broj: 0 },
      { name: "-", Broj: 0 },
      { name: "-", Broj: 0 }
    ],
    dataBetAmount: [
      { name: "-", Iznos: 0 },
      { name: "-", Iznos: 0 },
      { name: "-", Iznos: 0 },
      { name: "-", Iznos: 0 },
      { name: "-", Iznos: 0 },
      { name: "-", Iznos: 0 },
      { name: "-", Iznos: 0 },
      { name: "-", Iznos: 0 },
      { name: "-", Iznos: 0 },
      { name: "-", Iznos: 0 }
    ]
  };

  componentDidMount() {
    this.props.changeAdminLoadingIndicator(true);
    GetDashboardStats(
      this.props.machineInfo.MachineGUID,
      new Date(),
      this.getDashboardStats_Callback.bind(this)
    );
  }

  getDashboardStats_Callback = val => {
    this.props.changeAdminLoadingIndicator(false);

    if (!val || val === "?") {
      //javi
      //alert("err");
      return;
    }

    var dataCount = [];
    var dataAmount = [];

    //uredi listu za u state
    val.BetSummaries.forEach(bs => {
      dataCount.push({
        name: moment(bs.Date).format("DD.MM."),
        Broj: bs.BetCount
      });
      dataAmount.push({
        name: moment(bs.Date).format("DD.MM."),
        Iznos: bs.BetAmount.toFixed(2)
      });
    });

    //pobacaj u state
    this.setState({
      totalTickets: val.TotalTickets,
      totalPayIn: val.TotalPayIn,
      totalPayOut: val.TotalPayOut,
      remainingPaperMM: val.RemainingPaperMM,
      dataBetCount: dataCount,
      dataBetAmount: dataAmount
    });
  };

  render() {
    return (
      <div className={CssClasses.container}>
        <div className={CssClasses.contentBox}>
          <div className={CssClasses.statisticsRow}>
            <div className={CssClasses.statsInfo}>
              STANJE NA DAN {moment().format("DD.MM.YYYY.")}
            </div>
            <div className={CssClasses.statisticsContainer}>
              <div
                className={[CssClasses.statisticsBox, CssClasses.box1].join(
                  " "
                )}
                onClick={() => this.statsBoxClick(1)}
              >
                <span
                  className={[
                    SiteIcons.site_icon_admin_dashboard,
                    CssClasses.statsIcon
                  ].join(" ")}
                />
                <div className={CssClasses.statsValue}>
                  {this.state.totalTickets}
                </div>
                <div className={CssClasses.statsLegend}>Odigrano tiketa</div>
              </div>
            </div>
            <div className={CssClasses.statisticsContainer}>
              <div
                className={[CssClasses.statisticsBox, CssClasses.box2].join(
                  " "
                )}
                onClick={() => this.statsBoxClick(2)}
              >
                <span
                  className={[
                    SiteIcons.site_icon_admin_balance,
                    CssClasses.statsIcon
                  ].join(" ")}
                />
                <div className={CssClasses.statsValue}>
                  {this.state.totalPayIn}
                  {this.props.machineInfo.CurrencyCode}
                </div>
                <div className={CssClasses.statsLegend}>Iznos oklada</div>
              </div>
            </div>
            <div className={CssClasses.statisticsContainer}>
              <div
                className={[CssClasses.statisticsBox, CssClasses.box3].join(
                  " "
                )}
                onClick={() => this.statsBoxClick(3)}
              >
                <span
                  className={[
                    SiteIcons.site_icon_admin_invoice,
                    CssClasses.statsIcon
                  ].join(" ")}
                />
                <div className={CssClasses.statsValue}>
                  {this.state.totalPayOut}
                  {this.props.machineInfo.CurrencyCode}
                </div>
                <div className={CssClasses.statsLegend}>Iznos isplata</div>
              </div>
            </div>
            <div className={CssClasses.statisticsContainer}>
              <div
                className={[CssClasses.statisticsBox, CssClasses.box4].join(
                  " "
                )}
                onClick={() => this.statsBoxClick(4)}
              >
                <span
                  className={[
                    SiteIcons.site_icon_admin_tickets,
                    CssClasses.statsIcon
                  ].join(" ")}
                />
                <div className={CssClasses.statsValue}>
                  {this.state.remainingPaperMM > 0
                    ? (this.state.remainingPaperMM * 0.1 * 0.01).toFixed(2) +
                      "m"
                    : "-,--m"}
                </div>
                <div className={CssClasses.statsLegend}>Preostalo papira</div>
              </div>
            </div>
          </div>
          <div className={CssClasses.graphsRow}>
            <div className={CssClasses.graphContainer}>
              <div className={CssClasses.graphLegend}>
                BROJ ODIGRANIH TIKETA U ZADNJIH 10 DANA
              </div>
              <div className={CssClasses.graphBox}>
                <AreaChart
                  width={755}
                  height={500}
                  data={this.state.dataBetCount}
                  margin={{ top: 10, right: 40, left: -2, bottom: 0 }}
                >
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Area
                    type="monotone"
                    dataKey="Broj"
                    stroke="#000"
                    fill="#30815c"
                  />
                </AreaChart>
              </div>
            </div>
            <div className={CssClasses.graphContainer}>
              <div className={CssClasses.graphLegend}>
                IZNOS UPLATE U ZADNJIH 10 DANA
              </div>
              <div className={CssClasses.graphBox}>
                <AreaChart
                  width={755}
                  height={500}
                  data={this.state.dataBetAmount}
                  margin={{ top: 10, right: 40, left: -2, bottom: 0 }}
                >
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Area
                    type="monotone"
                    dataKey="Iznos"
                    stroke="#000"
                    fill="#30815c"
                  />
                </AreaChart>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  statsBoxClick = id => {
    switch (id) {
      case 1:
        this.props.setCurrentScreenID(
          AdminScreens.ADMIN_SCREEN_TICKET_OVERVIEW
        );
        break;
      case 2:
        this.props.setCurrentScreenID(AdminScreens.ADMIN_SCREEN_BILL_FLOW);
        break;
      case 3:
        this.props.setCurrentScreenID(AdminScreens.ADMIN_SCREEN_BILL_FLOW);
        break;
      case 4:
        this.props.setCurrentScreenID(AdminScreens.ADMIN_SCREEN_SETTINGS);
        break;
      default:
        break;
    }
  };
}

const mapStateToProps = state => {
  return {
    systemCombinations: state.rrTicket.systemCombinations,
    machineInfo: state.rrAppState.machineInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCurrentScreenID: screenID =>
      dispatch(StoreActions.ChangeCurrentAdminScreen(screenID)),
    setTicketNumberForDetails: ticketNumber =>
      dispatch(StoreActions.SetTicketNumberForDetails(ticketNumber)),
    changeAdminLoadingIndicator: isLoading =>
      dispatch(StoreActions.ChangeAdminLoadingIndicator(isLoading))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);



// WEBPACK FOOTER //
// ./src/Containers/AdminScreens/Dashboard/Dashboard.js